import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ReplaySubject, takeUntil } from 'rxjs';

import SurveyAnswer from 'entity/SurveyAnswer';
import SurveyQuestion from 'entity/SurveyQuestion';

import { AnswerService } from '../../services/answer.service';

@Component({
  selector: 'text-input-survey-card',
  templateUrl: './text-input-survey-card.component.html',
  styleUrls: ['./text-input-survey-card.component.scss'],
  standalone: false,
})
export class TextInputSurveyCardComponent implements OnInit, OnDestroy {
  @Input() public question?: SurveyQuestion;
  private answer?: SurveyAnswer;

  public formControl = new UntypedFormControl();
  private destroyed$ = new ReplaySubject<boolean>(1);

  public constructor(private _answerService: AnswerService) {}

  public ngOnInit(): void {
    this.answer = {
      surveyQuestionId: this.question?.surveyQuestionId,
      skipped: true,
    };
    this._answerService.trackAnswer(this.answer);
    this.detectChanges();
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  private detectChanges(): void {
    this.formControl.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe((val) => {
      if (!this.answer) {
        return;
      }
      if (val === '' || val === ' ') {
        this.answer.skipped = true;
        this.answer.answer = undefined;
      } else {
        this.answer.skipped = false;
        this.answer.answer = val;
      }
      this._answerService.trackAnswer(this.answer);
    });
  }
}
